import React from "react";
import "./Sales.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import invoiceImg from "../../../assets/images/State-Distributor/viewInvoice.png";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData1(
  productCode,
  product,
  uom,
  qty,
  price,
  total,
  discount,
  final
) {
  return {
    productCode,
    product,
    uom,
    qty,
    price,
    total,
    discount,
    final,
  };
}

const rows1 = [
  createData1(
    "004",
    "Royal Green",
    "10L",
    "1200",
    "₹400",
    "₹4,80,000",
    "5%",
    "₹4,56,000"
  ),
  createData1(
    "004",
    "Royal Green",
    "10L",
    "1200",
    "₹400",
    "₹4,80,000",
    "5%",
    "₹4,56,000"
  ),
];

export const ViewSales = () => {
  return (
    <div className="salesContainer">
      <div className="container">
        <div className="d-flex gap-1 mb-2">
          <span className="me-2">
            <Link to="/state-sales" style={{ color: "black" }}>
              <FaArrowLeftLong />
            </Link>
          </span>
          <div className="addModalTitle">View Invoice</div>
        </div>
        <div className="invoiceContainer">
          <div className="invoiceContent">
            <div>INV-2025-222</div>
            <div>09/09/2025</div>
          </div>
          <div className="invoiceContent">
            <div>State Distributor</div>
            <div>
              <span>96/854, Uppal,</span>
              <br />
              <span>Hyderabad, Telangana.</span>
              <br />
              <span>8523697410, 6363632501</span>
              <br />
            </div>
          </div>
          <div className="invoiceImg">
            <img src={invoiceImg} />
          </div>
        </div>
        <div className="invoiceAddress">
          <div>Billed To:</div>
          <div style={{ color: "var(--color-font-primary)", fontWeight: "600" }}>Ramesh,</div>
          <div>Sy no: 85/7, Kukatpally,</div>
          <div>Hyderabad, Telangana.</div>
          <div>9632587410</div>
        </div>
        {/* table  */}

        <div className="dashboardTableContainer">
          <TableContainer component={Paper}>
            <Table
              // sx={{ minWidth: 650 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead className="dashboadTableHeader">
                <TableRow>
                  <TableCell align="left">Product Code</TableCell>
                  <TableCell align="left">Product</TableCell>
                  <TableCell align="left">UOM</TableCell>
                  <TableCell align="left">Qty</TableCell>
                  <TableCell align="left">Price/Unit (₹)</TableCell>
                  <TableCell align="left">Total (₹)</TableCell>
                  <TableCell align="left">Discount (%)</TableCell>
                  <TableCell align="left">Final (₹)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows1.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    className="dashboardTableBody"
                  >
                    <TableCell align="left">{row.productCode}</TableCell>
                    <TableCell align="left">{row.price}</TableCell>
                    <TableCell align="left">{row.uom}</TableCell>
                    <TableCell align="left">{row.qty}</TableCell>

                    <TableCell align="left">{row.price}</TableCell>
                    <TableCell align="left">{row.total}</TableCell>
                    <TableCell align="left">{row.discount}</TableCell>
                    <TableCell align="left">{row.final}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
          {/* Totals */}
        <div className="addModalTotalContainer">
          <div>
            <div className="addModalContent">
              <span>Total Products:</span>
              <span>2400 nos</span>
            </div>
            <div className="addModalContent">
              <span>Subtotal:</span>
              <span>₹9,60,000</span>
            </div>
            <div className="addModalContent">
              <span>Discount:</span>
              <span>-₹48,000</span>
            </div>
             <div className="addModalContent">
              <span>Total Value:</span>
              <span>9,12,000</span>
            </div>
            <div className="addModalContent">
              <span>Amount Paid:</span>
              <span>9,12,000</span>
            </div>
              <div className="addModalContent">
              <span>Payment Status:</span>
              <span style={{color:'#10B981',fontWeight:'700'}}>Paid - Cash</span>
            </div>
          </div>
        </div>

            {/* Buttons */}
        <div className="d-flex justify-content-end">
             <div className="addModalButtons" style={{ marginTop: "20px",display:'flex',gap:'20px'}}>
          <button className="addBtnCancel">Cancel</button>
          <button className="addBtnSave">Print Invoice</button>
        </div>

        </div>
      </div>
    </div>
  );
};
